// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  position: relative;
}
.wrapper .cross-icon {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  padding: 10px;
  border-radius: 50%;
  z-index: 99;
}
.wrapper .cross-icon.top-right {
  top: 12px !important;
  right: 22px !important;
  transform: translateX(10px);
  left: auto;
  border: 1px solid black;
}
.wrapper .info-banner {
  max-height: 450px;
}
@media (min-width: 991px) {
  .wrapper .info-banner {
    min-height: 70vh;
  }
}
.wrapper .button-footer {
  width: 90%;
  position: absolute;
  bottom: 20px;
  height: 10%;
  left: 50%;
  transform: translateX(-50%);
  padding: 0px;
  font-size: 16px;
  min-height: 8%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/banner-img-modal/banner-img-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;AADJ;AAEI;EACI,kBAAA;EACA,YAAA;EACD,SAAA;EACA,2BAAA;EACC,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AAAR;AACQ;EACI,oBAAA;EACA,sBAAA;EACA,2BAAA;EACA,UAAA;EACA,uBAAA;AACZ;AAGI;EAII,iBAAA;AAJR;ACrBE;EDqBE;IAEQ,gBAAA;EAEV;AACF;AACI;EACI,UAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AACR","sourcesContent":["@import \"../../../theme/mixins\";\n\n.wrapper {\n    position: relative;\n    .cross-icon {\n        position: absolute;\n        bottom: 10px;\n       left: 50%;\n       transform: translateX(-50%);\n        background: white;\n        padding: 10px;\n        border-radius: 50%;\n        z-index: 99;\n        &.top-right {\n            top: 12px !important;\n            right: 22px !important;\n            transform: translateX(10px);\n            left: auto;\n            border: 1px solid black;\n        }\n    }\n\n    .info-banner {\n        @include desktop {\n            min-height: 70vh;\n        }\n        max-height: 450px;\n    }\n    .button-footer {\n        width: 90%;\n        position: absolute;\n        bottom: 20px;\n        height: 10%;\n        left: 50%;\n        transform: translateX(-50%);\n        padding: 0px;\n        font-size: 16px;\n        min-height: 8%;\n    }\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
